import { useQuery } from "react-query";

import { fetchClient } from "@/lib/fetchClient";
import type { ExtractFnReturnType, QueryConfig } from "@/lib/react-query";
import type { GetWorkflowResponse } from "@/types/resources";

async function getWorkflow(
  workflow_id: string
): Promise<GetWorkflowResponse | null> {
  if (workflow_id === "") {
    return null;
  }
  const { data } = await fetchClient.GET("/workflows/{workflow_id}", {
    params: { path: { workflow_id } },
  });
  if (data === undefined) {
    throw new Error("Failed to fetch workflow data");
  }
  return data;
}

type QueryFnType = typeof getWorkflow;

type UseWorkflowOptions = {
  workflow_id: string;
  config?: QueryConfig<QueryFnType>;
};

export const useWorkflow = ({ workflow_id, config }: UseWorkflowOptions) => {
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["workflow", workflow_id],
    queryFn: () => getWorkflow(workflow_id),
  });
  return query;
};
